module.exports = __webpack_public_path__ + "assets/img/notice.3eff4d71.svg";